function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { SelectionsLimitationType } from "../../../../../shared/types";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
import styles from "./CheckboxInput.module.scss";
const CheckboxInput = ({
  registerProps,
  isError,
  fieldSettings,
  selectedOptions,
  text
}) => {
  const isLimited = fieldSettings?.selections?.type === SelectionsLimitationType.Limited;
  const isMulti = fieldSettings?.isMultipleSelection;
  const maxSelect = fieldSettings?.selections?.selectionsCount;
  const selectionsCount = selectedOptions?.length || 0;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.checkboxWrapper
  }, fieldSettings?.options?.map(option => {
    const isSelected = selectedOptions ? selectedOptions?.includes(option?.id) : false;
    const disabled = isMulti ? isLimited && !isSelected && selectionsCount === maxSelect : !isSelected && selectionsCount > 0;
    return /*#__PURE__*/React.createElement("div", {
      key: option?.id,
      className: styles.checkboxInput
    }, /*#__PURE__*/React.createElement("input", _extends({
      value: option?.id,
      type: "checkbox"
    }, registerProps, {
      disabled: disabled
    })), /*#__PURE__*/React.createElement("label", null, text[option?.label?.textId]));
  }), isError && /*#__PURE__*/React.createElement(AlertCircleIcon, null));
};
export default CheckboxInput;
//# sourceMappingURL=CheckboxInput.js.map